var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Norway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#ff3d00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M17,5.3c-0.7,0.3-1.4,0.5-2,0.9V20H4.4c-0.1,0.7-0.2,1.3-0.3,2H17V5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M4.1,26c0.1,0.7,0.2,1.3,0.3,2H15v13.8c0.6,0.3,1.3,0.6,2,0.9V26H4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.9,22c-0.1-0.7-0.2-1.3-0.3-2H23V4.1c-0.7,0-1.3,0.1-2,0.2V22H43.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.6,28c0.1-0.7,0.2-1.3,0.3-2H21v17.8c0.7,0.1,1.3,0.2,2,0.2V28H43.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M43.9,26c0.1-0.7,0.1-1.3,0.1-2s0-1.3-0.1-2H21V4.2c-1.4,0.2-2.7,0.6-4,1V22H4.1C4,22.7,4,23.3,4,24 s0,1.3,0.1,2H17v16.7c1.3,0.5,2.6,0.8,4,1V26H43.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Norway);
export default __webpack_public_path__ + "static/media/icons8-norway.3760eae5152a92e3f899b86e2fe02649.svg";
export { ForwardRef as ReactComponent };